/* eslint-disable @nx/enforce-module-boundaries */
import React, { useState, useEffect, useRef } from 'react';
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionIcon,
  AccordionPanel,
} from '@mybridge/ui/accordion';
import { Text } from '@mybridge/ui/text';
import { TagPlus, TagTick, SimpleCloseIcon } from '@mybridge/icons';
import { HStack, Stack, Box, VStack } from '@mybridge/ui/layout';
import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  FormHelperText,
  Input,
  Checkbox,
  Select,
  Button,
} from '@mybridge/ui';
import _ from 'lodash';
import {
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
} from '@mybridge/ui';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';

const QuestionCards = ({
  item,
  index,
  onAnswerTextChange,
  onDelete,
  jobDetails,
  blockErrors = true,
}) => {
  const [newQuestion, setNewQuestion] = useState();
  const [newItem, setNewItem] = useState();
  const [textFieldChange, setTextFieldChange] = useState(false);
  const [textFieldValue, setTextFieldValue] = useState();
  const [textQuestion, setTextQuestion] = useState();
  const [errors, setErrors] = useState({});
  const [selectChange, setSelectChange] = useState(false);
  const [checkBoxChange, setCheckBoxChange] = useState(false);
  const { t } = useTranslator();
  const handleDelete = () => {
    onDelete(item);
  };

  useEffect(() => {
    if (item) {
      setNewQuestion(item.item.questions[0]);
      setNewItem(item);
      setTextQuestion(item?.item?.questions[0]?.question);
    }
  }, [item, index]);

  // const handleTextFieldChange = (i, event) => {
  //   const { name, value } = event.target;
  //   // console.log(item?.item?.questions[i]?.place_holder_value)
  //   setNewItem({
  //     ...newItem,
  //     item: {
  //       ...newItem.item,
  //       questions: [
  //         {
  //           ...newItem.item.questions[i],
  //           place_holder_value: value,
  //           question: findAndReplace(value)
  //         }
  //       ]
  //     }
  //   });
  //   setNewQuestion(newItem.item.questions[i]);
  //   setTextFieldValue(value);
  //   setTextFieldChange(true);
  // };
  const handleTextFieldChange = (i, event) => {
    // const { value } = event.target;
    let { value } = event.target;
    if (value && value.length > 0) {
      value = value.charAt(0).toUpperCase() + value.slice(1);
      event.target.value = value;
    }

    const updatedQuestionText = findAndReplace(value);

    const updatedItem = {
      ...newItem,
      item: {
        ...newItem.item,
        questions: [
          {
            ...newItem.item.questions[i],
            place_holder_value: value,
            question: updatedQuestionText,
          },
        ],
      },
    };

    setNewItem(updatedItem);
    setNewQuestion(updatedItem.item.questions[i]);
    setTextFieldValue(value);
    setTextFieldChange(true);
  };

  const handleSelectChange = (event) => {
    const { name, value } = event.target;
    setNewItem({
      ...newItem,
      item: {
        ...newItem.item,
        questions: [
          {
            ...newItem.item.questions[0],
            ideal_answer_value: value,
          }
        ]
      }
    });
    setSelectChange(true);
  };

  const handleIntegerChange = (event) => {
    setNewItem({
      ...newItem,
      item: {
        ...newItem.item,
        questions: [
          {
            ...newItem.item.questions[0],
            ideal_answer_value: event,
          }
        ]
      }
    });
    setSelectChange(true);
  };

  const handleCheckBoxChange = (event) => {
    const { name, checked } = event.target;
    // console.log(checked);
      setNewItem({
        ...newItem,
        item: {
          ...newItem.item,
          questions: [
            {
              ...newItem.item.questions[0],
              is_must_have: checked,
            }
          ]
        }
      });
    setCheckBoxChange(true);
  };

  // useEffect(() => {
  //   if (textFieldChange || checkBoxChange || selectChange)
  //     setNewItem(_.set(_.cloneDeep(newItem), 'questions', newQuestion));
  // }, [textFieldChange, checkBoxChange, selectChange]);

  // const findAndReplace = (value) => {
  //   // Create a regular expression to find the string between [name] brackets
  //   const regex = /\[.*?\]/;

  //   // Use the replace method to replace [name] with the dynamic value
  //   const newText = item?.item?.questions[0]?.question.replace(
  //     regex,
  //     value ? value : textFieldValue
  //   );

  //   // Update the state with the new text
  //   setTextQuestion(newText);
  //   return newText;
  // };

  const findAndReplace = (value) => {
    const regex = /\[.*?\]/;

    // Always use the template/original question
    const baseText = newItem?.item?.questions[0]?.question_original 
                  || item?.item?.questions[0]?.question;

    const newText = baseText.replace(
      regex,
      value ? value : textFieldValue
    );

    setTextQuestion(newText);
    return newText;
  };

  useEffect(() => {
    if (textFieldValue) {
      findAndReplace();
    }
  }, [textFieldValue]);

  useEffect(() => {
    if (newItem) {
      onAnswerTextChange(newItem);
    }
  }, [newItem]);

  useEffect(() => {
    const newErrors = {};
    // if(newQuestion?.is_must_have === false){
    //   newErrors.is_must_have = 'error';
    //   blockErrors = true
    // }
    if (
      newItem?.item?.questions[0]?.ideal_answer_text !== null &&
      newItem?.item?.questions[0]?.place_holder_value === null
    ) {
      newErrors.place_holder_value = 'error';
      blockErrors = true;
    }
    newErrors.index = index;
    setErrors(newErrors);
  }, [newItem]);

  // console.log(newItem);

  return (
    <Accordion allowMultiple defaultIndex={[0]} mb={3} key={index}>
      <AccordionItem border="1px solid #E4E6EB" borderRadius="8px">
        {({ isExpanded }) => (
          <>
            <h2>
              <AccordionButton minH="60px" h="auto" py={3} backgroundColor="brandGray.500">
                <Box as="span" flex="1" textAlign="left">
                  <Text
                    color="brandGray.800"
                    fontSize="md"
                    fontWeight="semibold"
                  >
                    {/* {textQuestion} [{item?.item?.name}] */}
                    {item?.item?.name?.toLowerCase() === 'resume' ? item?.item?.name : `${textQuestion} [${item?.item?.name}]`}
                  </Text>
                </Box>
                <SimpleCloseIcon onClick={() => handleDelete()} />
              </AccordionButton>
            </h2>
            <AccordionPanel pb={4}>
              <Stack>
                  {/* {newItem?.item?.questions?.map((question, i) => (
                    <HStack
                      w="100%"
                      justifyContent="space-between"
                      key={i}
                      pe="100px"
                    >
                      {question.ideal_answer_text !== null && (
                        <VStack>
                          <FormControl
                            isInvalid={
                              errors.index === index &&
                              errors.place_holder_value
                                ? true
                                : false
                            }
                          >
                            <FormLabel htmlFor="place_holder_value">
                              {question.ideal_answer_text}
                            </FormLabel>
                            <Input
                              type="text"
                              variant="whiteInput"
                              placeholder={question.ideal_answer_text}
                              name="place_holder_value"
                              // onChange={(e) => handleTextFieldChange(e)}
                              // onBlur={(e) => handleTextFieldChange(i, e)}
                              onChange={(e) => handleTextFieldChange(i, e)}
                              defaultValue={question.place_holder_value}
                              errorBorderColor="brandRed.500"
                              px={2}
                              // textTransform="capitalize"
                            />
                            {errors.index === index &&
                            errors.place_holder_value ? (
                              <FormErrorMessage>
                                {t('createJob.fieldIsRequired') || "Field is required"}
                              </FormErrorMessage>
                            ) : (
                              ''
                            )}
                          </FormControl>
                        </VStack>
                      )}
                      {question.ideal_answer_type === 'bool' && (
                        <VStack align="flex-start">
                          <Text>{t('createJob.idealAnswer') || "Ideal Answer"}</Text>
                          <Text fontWeight="bold">
                            {question.ideal_answer_value}
                          </Text>
                        </VStack>
                      )}
                      {question.ideal_answer_type === 'integer' && (
                        <VStack align="flex-start">
                          <Text>{t('createJob.idealAnswer') || "Ideal Answer"}</Text>
                          <HStack>
                            // Input type="number" value="1" w="50px"
                            <NumberInput
                              w="80px"
                              min={0}
                              variant="whiteInput"
                              defaultValue={question.ideal_answer_value}
                              step={item?.item?.name === 'GPA' ? 0.1 : 1}
                              max={item?.item?.name === 'GPA' ? 4.0 : 50}
                              onChange={(e) => handleIntegerChange(e)}
                            name="ideal_answer_value"
                            >
                              <NumberInputField />
                              <NumberInputStepper>
                                <NumberIncrementStepper />
                                <NumberDecrementStepper />
                              </NumberInputStepper>
                            </NumberInput>
                            <Text>{t('createJob.minimum') || "minimum"}</Text>
                          </HStack>
                        </VStack>
                      )}

                      {question.ideal_answer_text === 'Language' && (
                        <VStack align="flex-start">
                          <Text>{t('createJob.idealAnswer') || "Ideal Answer"}</Text>
                          <Select
                            onChange={(e) => handleSelectChange(e)}
                            name="ideal_answer_value"
                          >
                            <option value="basic">{t('createJob.basic') || "Basic"}</option>
                            <option value="convers">{t('createJob.conversation') || "Conversation"}</option>
                            <option value="fluent">{t('createJob.fluent') || "Fluent"}</option>
                          </Select>
                        </VStack>
                      )}
                      <VStack>
                        <FormControl>
                          <FormLabel htmlFor="is_must_have">{''}</FormLabel>
                          <Checkbox
                            defaultChecked={question?.is_must_have}
                            name="is_must_have"
                            onChange={(e) => handleCheckBoxChange(e)}
                          >
                            {t('createJob.mustHaveQualification') || "Must-have qualification"}
                          </Checkbox>
                        </FormControl>
                      </VStack>
                      // <VStack>
                      //   <Button
                      //     variant="primary"
                      //     onClick={() => handleSubmit()}
                      //   >
                      //     Add
                      //   </Button>
                      // </VStack>
                    </HStack>
                  ))} */}

                  {newItem?.item?.questions?.map((question, i) => {
                    if (item?.item?.name?.toLowerCase() === 'resume') {
                      return (
                      
                        <Stack
                          direction={['column', 'row']}
                          w="100%"
                          justifyContent="space-between"
                          alignItems={['flex-start', 'center']}
                          key={i}
                          pe={['0px', '20px', '100px']}
                          spacing={3}
                        >
                          <Text>{question.question}</Text>
                          <VStack align="flex-start">
                            <FormControl>
                              <FormLabel htmlFor="is_must_have">{''}</FormLabel>
                              <Checkbox
                                defaultChecked={question?.is_must_have}
                                name="is_must_have"
                                onChange={(e) => handleCheckBoxChange(e)}
                              >
                                {t('createJob.mustHaveQualification') || "Must-have qualification"}
                              </Checkbox>
                            </FormControl>
                          </VStack>
                        {/* </HStack> */}
                        </Stack>
                      );
                    }
                    return (
                     
                      <Stack
                        direction={['column', 'row']}
                        w="100%"
                        justifyContent="space-between"
                        alignItems={['flex-start', 'center']}
                        key={i}
                        pe={['0px', '20px', '100px']}
                        spacing={3}
                      >
                        {question.ideal_answer_text !== null && (
                          <VStack align="flex-start" w={['100%', 'auto']}>
                            <FormControl
                              isInvalid={
                                errors.index === index &&
                                errors.place_holder_value
                                  ? true
                                  : false
                              }
                            >
                              <FormLabel htmlFor="place_holder_value">
                                {question.ideal_answer_text}
                              </FormLabel>
                              <Input
                                type="text"
                                variant="whiteInput"
                                placeholder={question.ideal_answer_text}
                                name="place_holder_value"
                                onChange={(e) => handleTextFieldChange(i, e)}
                                defaultValue={question.place_holder_value}
                                errorBorderColor="brandRed.500"
                                px={2}
                              />
                              {errors.index === index &&
                              errors.place_holder_value ? (
                                <FormErrorMessage>
                                  {t('createJob.fieldIsRequired') || "Field is required"}
                                </FormErrorMessage>
                              ) : (
                                ''
                              )}
                            </FormControl>
                          </VStack>
                        )}
                        {question.ideal_answer_type === 'bool' && (
                          <VStack align="flex-start">
                            <Text>{t('createJob.idealAnswer') || "Ideal Answer"}</Text>
                            <Text fontWeight="bold">
                              {question.ideal_answer_value}
                            </Text>
                          </VStack>
                        )}
                        {question.ideal_answer_type === 'integer' && (
                          <VStack align="flex-start">
                            <Text>{t('createJob.idealAnswer') || "Ideal Answer"}</Text>
                            <HStack>
                              <NumberInput
                                w="80px"
                                min={0}
                                variant="whiteInput"
                                defaultValue={question.ideal_answer_value}
                                step={item?.item?.name === 'GPA' ? 0.1 : 1}
                                max={item?.item?.name === 'GPA' ? 4.0 : 50}
                                onChange={(e) => handleIntegerChange(e)}
                                name="ideal_answer_value"
                              >
                                <NumberInputField />
                                <NumberInputStepper>
                                  <NumberIncrementStepper />
                                  <NumberDecrementStepper />
                                </NumberInputStepper>
                              </NumberInput>
                              <Text>{t('createJob.minimum') || "minimum"}</Text>
                            </HStack>
                          </VStack>
                        )}

                        {question.ideal_answer_text === 'Language' && (
                          <VStack align="flex-start">
                            <Text>{t('createJob.idealAnswer') || "Ideal Answer"}</Text>
                            <Select
                              onChange={(e) => handleSelectChange(e)}
                              name="ideal_answer_value"
                            >
                              <option value="basic">{t('createJob.basic') || "Basic"}</option>
                              <option value="convers">{t('createJob.conversation') || "Conversation"}</option>
                              <option value="fluent">{t('createJob.fluent') || "Fluent"}</option>
                            </Select>
                          </VStack>
                        )}
                        <VStack align="flex-start">
                          <FormControl>
                            <FormLabel htmlFor="is_must_have">{''}</FormLabel>
                            <Checkbox
                              defaultChecked={question?.is_must_have}
                              name="is_must_have"
                              onChange={(e) => handleCheckBoxChange(e)}
                            >
                              {t('createJob.mustHaveQualification') || "Must-have qualification"}
                            </Checkbox>
                          </FormControl>
                        </VStack>
                      {/* </HStack> */}
                      </Stack>
                    );
                  })}
              </Stack>
            </AccordionPanel>
          </>
        )}
      </AccordionItem>
    </Accordion>
  );
};

export default QuestionCards;
